import { defineMessages } from 'react-intl';

export const messages: {
	chat: { id: string; defaultMessage: string; description: string };
	search: { id: string; defaultMessage: string; description: string };
	searchForQuery: { id: string; defaultMessage: string; description: string };
	resultsHeading: { id: string; defaultMessage: string; description: string };
} = defineMessages({
	chat: {
		id: 'search-page.quick-find.dialog.chat-intent-router.chat',
		defaultMessage: 'Ask Rovo',
		description: 'Label for the Quick Find row that opens the current query in Rovo chat on Home.',
	},
	search: {
		id: 'search-page.quick-find.dialog.chat-intent-router.search',
		defaultMessage: 'Search all apps',
		description:
			'Label for the Quick Find row that runs the current query across all connected apps in full page search.',
	},
	searchForQuery: {
		id: 'search-page.quick-find.dialog.chat-intent-router.search-for-query',
		defaultMessage: 'Search',
		description: 'Placeholder shown in a Quick Find chat/search row when the query text is empty.',
	},
	resultsHeading: {
		id: 'search-page.quick-find.dialog.chat-intent-router.results-heading',
		defaultMessage: 'Search results',
		description: 'Accessible label for the list of chat/search destination rows in Quick Find.',
	},
});
